// extracted by mini-css-extract-plugin
module.exports = {"tags__list":"Tags_tags__list__Xm79l","tags__item":"Tags_tags__item__zeNq2"};